import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import TopicHeaderRefreshedQuery, {
	type TopicHeaderRefreshedQuery as TopicHeaderRefreshedQueryType,
} from '../ui/TopicHeaderRefreshed/__generated__/TopicHeaderRefreshedQuery.graphql';

export const topicViewHeaderResource: RouteResource<
	PreloadedQuery<TopicHeaderRefreshedQueryType, Record<string, unknown>>
> = createRelayResource<TopicHeaderRefreshedQueryType>({
	getQuery: (routerContext) => {
		return {
			query: TopicHeaderRefreshedQuery,
			variables: {
				tagUuid: routerContext.match.params.uuid ?? '',
				trackViewEvent: 'DIRECT',
			},
		};
	},
});
